import {Component, OnInit, Renderer2} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {Globals} from '../../../services/globals.service';
import {MockDataService} from '../../../services/mock-data.service';
import {ElectricityService} from '../../../services/electricity.service';
import {ApplicationService} from '../../../services/application.service';
import {TILE_TYPE, TileService} from '../../../services/tile.service';
import {TrackAnalyticsService} from '../../../services/track-analytics.service';
import {AnimationItem} from 'lottie-web';
import {FinanceTileTexts} from '../../../shared/texts/tiles/finance-tile.texts';
import {AnimationOptions} from 'ngx-lottie';

@Component({
    selector: 'app-finance-tile',
    templateUrl: './finance-tile.component.html',
    styleUrls: ['./finance-tile.component.scss'],
    providers: [Globals]
})

export class FinanceTileComponent implements OnInit {
    private readonly type: TILE_TYPE = TILE_TYPE.FINANCE;
    readonly TEXTS = FinanceTileTexts;

    finance: any = {
        trend: 0,
        amount: 0,
        percent: 0
    };

    dataAvailable = false;

    lottieConfig: AnimationOptions = {
        path: 'assets/anim/finance.json',
        renderer: 'svg',
        autoplay: true,
        loop: true,
        name: 'Smart Meter',
    };

    private animation = null;

    constructor(private _apiService: ApiService,
                private _globals: Globals,
                private _mockData: MockDataService,
                private electricity: ElectricityService,
                private application: ApplicationService,
                private analytics: TrackAnalyticsService,
                private tiles: TileService,
                private renderer: Renderer2) {
    }

    /**
     * Widget "Abschlags-Check" ist aktuell deaktiviert
     */
    ngOnInit() {
        this.getFinanceData();
    }

    onTileClicked(): void {
        this.detailEntered();
        this.tiles.openDetailView(this.type);
    }


    animationCreated(anim: AnimationItem) {
        this.animation = anim;
        this.renderer.setStyle(this.animation.wrapper, 'width', '100%');
        this.renderer.setStyle(this.animation.wrapper, 'height', '100%');
    }

    private getFinanceData(): void {
        const s = this.electricity.getBillPrediction().subscribe(
            (res: any) => {
                try {
                    if (res.sum_of_prepayments > 12) {
                        this.dataAvailable = true;
                        this.extractFinanceData(res);
                    }
                } catch (e) {
                }
                s.unsubscribe();
            },
            (error) => {
                console.log('Error:', error);
            }
        );
    }

    private extractFinanceData(data: any): void {
        const estimated_cost = data.estimated_cost_billing_period;
        const sum_prepayments = data.sum_of_prepayments;

        const difference = estimated_cost - sum_prepayments;
        const percentage = 100 * (difference) / sum_prepayments;

        this.dataAvailable = sum_prepayments > 12 && (percentage > -50 && percentage < 50);
        this.finance.percent = Math.round(percentage);

        if (percentage > 10 && difference > 10) { // additional payment
            this.finance.amount = Math.ceil(difference / 10) * 10;
            this.finance.trend = 1;
        } else if (percentage < -10 && difference < -10) { // credit voucher
            this.finance.amount = Math.abs(Math.floor(difference / 10) * 10);
            this.finance.trend = -1;
        } else {
            this.finance.trend = 0;
            this.finance.amount = 0;
        }
    }

    detailEntered() {
        if (!(this._globals.getFirstDetailsViewed())) {
            this.trackFirstDetailView();
        }
        this._globals.setFirstDetailsViews();
        this.trackDetailsEntered();
    }

    private trackDetailsEntered(): void {
        this.analytics.trackEvent({
            action: 'dashboard_tile_tapped',
            properties: {
                category: 'Tiles',
                label: 'Tile: Finance',
            }
        });
    }

    private trackFirstDetailView(): void {
        // Erstes aufrufen eines Detail Screens
        this.analytics.trackEvent({
            action: 'first_detail_view',
            properties: {
                category: 'Screens',
                label: 'Screen: Finance-Details'
            }
        });
    }
}
